<template lang="pug">
.product-details.container.mx-auto.px-4(ref="container")
    .product-wrap
        .loading(v-if="loading" key="spinner")
            //- TODO: skeleton
            Spinner(:size="10" :thickness="2")
        .details(v-else-if="product" :class="[transition]" key="details")
            .media(ref="media")
                .active-media.relative(v-if="activeMedia && mediaWidth")
                    img.sale-image(v-if="sale" title="sale" src="~@/assets/img/sale.png")
                    ProductImage(
                        v-if="activeMedia.type === 'image'"
                        :key="`main-${activeMedia.id}`"
                        :media="activeMedia"
                        :product="product"
                        :preferred-width="mediaWidth"
                    )

            .info.zoom-container
                .info-container
                    .name-wrap
                        h2.name {{ nr.replace(/(\d-\d.-)/,'') + ' ' + name }}
                        //- .nr Artikel-Nr. {{ nr }}
                    .price-warp
                        nobr.ek-price(:class="{ strikethrough: salePrice }") EK {{ price }}
                        nobr.uvp-price(v-if="uvpPriceRange" :class="{ strikethrough: salePrice }")
                            small.mr-1(v-if="sale") ehemaliger
                            span UVP {{ uvpPriceRange }}
                        nobr.uvp-price(v-else-if="uvp" :class="{ strikethrough: salePrice }")
                            small.mr-1(v-if="sale") ehemaliger
                            span UVP {{ uvp }}
                        nobr.sale(v-if="salePrice") {{ salePrice }}
                        .tax-info(v-if="!customer || !customer.show_net_prices") zzgl. {{ taxRate }} MwSt.

                .description.mb-4(v-if="description")
                    label Beschreibung
                    .value(v-html="description")
                .properties
                    ProductProperty(
                        v-for="property in properties"
                        v-if="property.label === 'Material'|| property.label === 'Futter'"
                        :valid="valid"
                        :key="`${product.id}-${property.id}`"
                        :property="property"
                        :active-option="selectedOptions[property.id]"
                        :sellable-articles="sellableArticles"
                        :valid-articles="validArticles"
                        :manage-stock="product.manage_stock"
                        @select="selectPropertyOption"
                    )
                //- .properties
                //-     ProductProperty(
                //-         v-for="property in properties"
                //-         v-if="property.label !== 'Ausführliche Beschreibung'"
                //-         :valid="valid"
                //-         :key="`${product.id}-${property.id}`"
                //-         :property="property"
                //-         :active-option="selectedOptions[property.id]"
                //-         :sellable-articles="sellableArticles"
                //-         :valid-articles="validArticles"
                //-         :manage-stock="product.manage_stock"
                //-         @select="selectPropertyOption"
                //-     )
                
                img.carelabel-image(v-if="careLabelImage" :src="careLabelImage")
                img.label-image(v-if="labelImage.title.length" :title="labelImage.title" :alt="labelImage.title" :src="labelImage.url")

                //.buttons(v-if="valid" :class="{ active: validPropertySelection && validArticles && validArticles.length === 1 }")
                    .left
                        .custom-number-input
                            button.decrease(@click="qty = Math.max(1, qty - 1)")
                                span.m-auto.text-2xl.font-thin &minus;
                            input.border-black.border-solid.border-1(type="number" name="custom-input-number" v-model="qty")
                            button.increase(@click="qty = Math.min(maxQty, qty + 1)")
                                span.m-auto.text-2xl.font-thin +
                    .right
                        button.button.add-to-shopping-cart(v-if="valid" @click="addToCart") In den Warenkorb
        .not-found(v-else key="not-found")
            Error.error(:code="404" message="Produkt konnte nicht gefunden werden")

    .thumbnails(v-if="media && media.length > 1")
        //carousel(:items="5" :responsive="{0:{items:3},600:{items:5}}" @updated="updated" :margin="20" :dots="false")
        hooper(:settings="carouselSettings" :class="{ hideNavLG : media.length <= 5, hideNavXS : media.length < 3  }")
            slide(v-for="(el, m) in media" :key="el.id")
                PreviewImage(
                    v-if="el.type === 'image'"
                    :key="el.id"
                    :media="el"
                    :product="product"
                    :preferred-width="198"
                    :maximized="el.id === activeMedia.id"
                    @maximize="data => selectMedia(m)"
                )
            hooper-navigation(slot="hooper-addons")
    .preorder-table(v-if="product != undefined")
      template(v-for="group in articleGroups")
        h3(v-if="group.name") {{ group.name }}
        Preorder(
          :valid="valid"
          :article-properties="group.properties"
          :product-properties="configurableProductProperties"
          :articles="group.articles"
          :valid-articles="validArticles"
          :selected-options="selectedOptions"
          :manage-stock="product.manage_stock"
          @select-property="selectPropertyOption"
          @toggle-active-article="toggleActiveArticle"
          :productUvp="uvp"
        )
    RelatedArticles(v-if="relatedArticles && relatedArticles.length" :section="relatedArticles")
        //- Preorder(
        //-   v-if="product != undefined"
        //-   :valid="valid"
        //-   :article-properties="articleProperties"
        //-   :product-properties="configurableProductProperties"
        //-   :articles="product.articles"
        //-   :valid-articles="validArticles"
        //-   :selected-options="selectedOptions"
        //-   :manage-stock="product.manage_stock"
        //-   @select-property="selectPropertyOption"
        //-   @toggle-active-article="toggleActiveArticle"
        //-   :productUvp="uvp"
        //- )

</template>

<script>
import uniqid from 'uniqid';
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper';
import 'hooper/dist/hooper.css';

import { mapActions, mapGetters, mapMutations } from 'vuex';

import { get, debounce, cloneDeep } from '@/helpers';
import { moneyFormat } from '@/filters';

import Error from '@/components/Error';
import ProductImage from '@/extensions/shop/components/ProductImage';
import PreviewImage from '@/extensions/shop/components/PreviewImage';
import ProductProperty from '@/extensions/shop/components/ProductProperty';
import Preorder from '@/extensions/shop/components/Preorder.vue';
import RelatedArticles from '@/extensions/shop/components/RelatedArticles';

export default {
    name: 'ProductDetailPage',
    data: () => ({
        loading: false,
        product: undefined,
        m: 0, // active media key
        mediaWidth: undefined,
        activeArticle: false,
        selectedOptions: {}, // key is property id
        transition: {
            // transition classes
            'slide-fade-enter': true,
            'slide-fade-enter-active': false,
            'slide-fade-leave-active': false,
            'slide-fade-leave-to': false
        },
        carouselSettings: {
            itemsToShow: 5,

            mouseDrag: false,
            touchDrag: true,
            wheelControl: false,
            breakpoints: {
                1024: {
                    itemsToShow: 5,
                    itemsToSlide: 5
                },
                0: {
                    itemsToShow: 3,
                    itemsToSlide: 3
                }
            }
        },
        qty: 1
    }),
    components: {
        Error,
        ProductImage,
        PreviewImage,
        ProductProperty,
        RelatedArticles,
        Preorder,
        Hooper,
        Slide,
        HooperNavigation
    },
    watch: {
        qty(value) {
            if (value < 1) this.qty = 1;
            else if (value > this.maxQty) this.qty = this.maxQty;
        }
    },
    computed: {
        nr() {
            return this.product.nr;
        },
        name() {
            let name = this.product.name;

            if (this.validArticles && this.validArticles.length && this.validArticles[0].name) {
                name = this.validArticles[0].name;
            }

            return name;
        },
        description() {
            let description = get(this.product, 'description');

            return description;
        },

        labelImage() {
            let label = {},
                title,
                url;
            const labelObj = this.properties.find(setting => setting.key === 'collection-label') || [];

            if (labelObj.options && labelObj.options.length) {
                title = labelObj.options[0].value;
                url =
                    '/img/label/' +
                    labelObj.options[0].value
                        .toLowerCase()
                        .replace(/[^a-zA-Z ]/g, '')
                        .replace(/\s/g, '_') +
                    '.png';
            }
            return (label = {
                url: url,
                title: title
            });
        },
        careLabelImage() {
            let url = undefined;
            const labelObj = this.properties.find(setting => setting.key === 'care-label') || [];

            if (labelObj.options && labelObj.options.length) {
                url = '/img/carelabels/' + labelObj.options[0].value + '_Carelabels.jpg';
            }  

            return url;
        },
        // component() {
        //     let component = 'component';
        //     if (
        //         this.articleProperties.length === 2 &&
        //         this.configurableArticleProperties.length <= 2 &&
        //         this.configurableProductProperties.length === 0 &&
        //         this.display === 'preorder'
        //     ) {
        //         component = 'preorder';
        //     } else if (this.configurableArticleProperties.length === 2 && this.display === 'matrix') {
        //         component = 'matrix';
        //     }
        //     return component;
        // },
        sale() {
            const propertyPivots = this.product.propertyPivots || [];
            return propertyPivots.find(
                el => el.property.key === 'sale' && el.values.length === 1 && el.values[0].number === 1
            );
        },
        media() {
            let media = [];
            if (this.activeArticle && this.activeArticle.media) {
                media = this.activeArticle.media;
            } else if (this.product && this.product.media) {
                media = this.product.media;

                if (
                    this.validPropertySelection &&
                    this.validArticles &&
                    this.validArticles.length &&
                    this.validArticles[0].media &&
                    this.validArticles[0].media.length
                )
                    media = this.validArticles[0].media;

                media = media.filter(el => {
                    return get(el, 'settings.show.detail', true) === true;
                });
            }

            return media;
        },
        properties() {
            let properties = [];

            const normalizePropertyOptions = el => {
                const propType = el.property.propType;
                let options = el.values.map(el => {
                    const key = propType.value_field;
                    const value = get(el, key);

                    let valueAlt;
                    const keyAlt = propType.value_field_alt;
                    if (keyAlt) valueAlt = get(el, keyAlt);

                    return {
                        id: el.id,
                        image: el.image,
                        value,
                        valueAlt,
                        key
                    };
                });
                return options;
            };

            if (this.product.propertyPivots && this.product.propertyPivots.length) {
                this.product.propertyPivots.forEach(el => {
                    const id = el.property.id;
                    const key = el.property.key;
                    const label = el.property.name;
                    const visible = el.property.visible_on_product_listing || el.property.visible_on_detail_page;
                    const type = el.property.propType.key;

                    // const propType = el.property.propType;
                    const articleRequired = el.property.article_required;

                    // let key = el.key
                    const options = normalizePropertyOptions(el);
                    let property = {
                        id,
                        key,
                        type,
                        label,
                        options,
                        articleRequired,
                        visible
                    };

                    // if (el.key.toLowerCase() === 'länge') {
                    //   property.label = 'length';
                    // }
                    properties.push(property);
                });
            }

            return properties.filter(property => {
                return property.visible !== false || property.options.length > 1;
            });
        },
        valid() {
            // check if this product is valid
            // by required stuff is missing
            // - price
            // ...
            return !!this.product.price;
        },
        // price() {
        //     if (!this.product.price) return null;
        //     return this.getPrice();
        // },
        // salePrice() {
        //     if (!this.product.salePrice) return null;
        //     return this.getPrice('salePrice');
        // },
        taxRate() {
            if (!this.product.price) return null;

            let string = this.product.price.tax.value.toString() + '%';

            // get all prices from related articles
            // define range

            let range = {
                from: this.product.price.tax.value,
                to: this.product.price.tax.value
            };

            if (this.validArticles && this.validArticles.length) {
                this.validArticles.forEach(article => {
                    if (article.price) {
                        range.from = Math.min(range.from, article.price.tax.value);
                        range.to = Math.max(range.from, article.price.tax.value);
                    }
                });

                if (range.from < range.to) {
                    string = `${range.from}% - ${range.to}%`;
                }
            }

            return string;
        },
        uvpPriceRange() {
            if (!this.product.mainPrice || !this.uvpCustomerGroup) return null;
            const code =
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR';
            let price = this.product.prices.filter(uvpprice => {
                if (parseInt(this.uvpCustomerGroup) === 81) {
                    return uvpprice.customerGroup === null;
                } else {
                    return parseInt(uvpprice?.customerGroup?.id) === parseInt(this.uvpCustomerGroup);
                }
            });
            if (price.length) {
                price = price[0];
            } else {
                price = false;
            }
            let string;
            if (price) {
                let key = 'value';
                // if (this.customer && get(this.customer, 'show_net_prices')) key = 'net_value';

                // return moneyFormat(price.value - tax, code);
                string = moneyFormat(price[key], code);
                // get all prices from related articles
                // define range
                let range = {
                    from: price[key],
                    to: price[key]
                };
                if (this.validArticles && this.validArticles.length) {
                    let article_prices;
                    this.validArticles.forEach(article => {
                        article_prices = article.prices.filter(uvpprice => {
                            if (parseInt(this.uvpCustomerGroup) === 81) {
                                return uvpprice.customerGroup === null;
                            } else {
                                return parseInt(uvpprice?.customerGroup?.id) === parseInt(this.uvpCustomerGroup);
                            }
                        });
                        if (article_prices && article_prices.length) {
                            article_prices.forEach(art_price => {
                                if (range === undefined)
                                    range = {
                                        from: art_price[key],
                                        to: art_price[key]
                                    };
                                range.from = Math.min(range.from, art_price[key]);
                                range.to = Math.max(range.from, art_price[key]);
                            });
                        }
                    });
                }
                if (range && range.from < range.to) {
                    string = 'ab ' + moneyFormat(range.from, code);
                    // string = moneyFormat(range.from, code) + ' - ' + moneyFormat(range.to, code);
                } else if (range) {
                    string = moneyFormat(range.from, code);
                }
            } else string = false;
            return string;
        },
        uvp() {
            if (!this.product.mainPrice || !this.uvpCustomerGroup) return null;
            const code =
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR';
            let price = this.product.prices.filter(uvpprice => {
                if (parseInt(this.uvpCustomerGroup) === 81) {
                    return uvpprice.customerGroup === null;
                } else {
                    return parseInt(uvpprice?.customerGroup?.id) === parseInt(this.uvpCustomerGroup);
                }
            });
            if (price.length) {
                price = price[0];
            } else {
                price = false;
            }
            let string;
            if (price) {
                let key = 'value';
                // if (this.customer && get(this.customer, 'show_net_prices')) key = 'net_value';

                // return moneyFormat(price.value - tax, code);
                string = moneyFormat(price[key], code);

                // get all prices from related articles
                // define range

                // let range = {
                //     from: price[key],
                //     to: price[key]
                // };
                // if (this.validArticles && this.validArticles.length) {
                //     let article_prices;
                //     this.validArticles.forEach(article => {
                //         article_prices = article.prices.filter(uvpprice => {
                //             if (parseInt(this.uvpCustomerGroup) === 81) {
                //                 return uvpprice.customerGroup === null;
                //             } else {
                //                 return parseInt(uvpprice?.customerGroup?.id) === parseInt(this.uvpCustomerGroup);
                //             }
                //         });
                //         console.log(article_prices);
                //         if (article_prices && article_prices.length) {
                //             article_prices.forEach(art_price => {
                //                 if (range === undefined)
                //                     range = {
                //                         from: art_price[key],
                //                         to: art_price[key]
                //                     };
                //                 range.from = Math.min(range.from, art_price[key]);
                //                 range.to = Math.max(range.from, art_price[key]);
                //             });
                //         }
                //     });
                // }
                // console.log(range);
                // if (range && range.from < range.to) {
                //     string = 'ab ' + moneyFormat(range.from, code);
                //     // string = moneyFormat(range.from, code) + ' - ' + moneyFormat(range.to, code);
                // } else if (range) {
                //     string = moneyFormat(range.from, code);
                // }
            } else string = false;
            return string;
        },
        uvpCustomerGroup() {
            let currentCustomerGroup = get(this.customer, 'customerGroup');
            let customerGroup;
            switch (parseInt(currentCustomerGroup?.id)) {
                case 84:
                    customerGroup = 81;
                    break;
                case 102:
                    customerGroup = 112;
                    break;
                case 103:
                    customerGroup = 113;
                    break;
                case 104:
                    customerGroup = 114;
                    break;
                case 105:
                    customerGroup = 115;
                    break;
                case 106:
                    customerGroup = 116;
                    break;
                case 110:
                    customerGroup = 117;
                    break;
                default:
                    customerGroup = currentCustomerGroup?.id;
                    break;
            }
            return parseInt(customerGroup);
        },
        price() {
            if (!this.product.price) return null;

            let currentCustomerGroup = get(this.customer, 'customerGroup');
            const code =
                get(currentCustomerGroup, 'currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR';

            let key = 'net_value';
            if (this.customer && get(this.customer, 'show_net_prices')) key = 'net_value';
            let price = this.product.price;
            // return moneyFormat(price.value - tax, code);
            let string = moneyFormat(price[key], code);

            // get all prices from related articles
            // define range

            let range = {
                from: price[key],
                to: price[key]
            };

            if (this.validArticles && this.validArticles.length) {
                this.validArticles.forEach(article => {
                    let article_price = null;
                    if (article.price) {
                        switch (parseInt(this.currentCustomerGroup?.id)) {
                            case 81:
                                article_price = article.prices.find(price => {
                                    return parseInt(price.customerGroup.id) === 84;
                                });
                                break;
                            case 102:
                                article_price = article.prices.find(price => {
                                    return parseInt(price.customerGroup.id) === 112;
                                });
                                break;
                            case 103:
                                article_price = article.prices.find(price => {
                                    return parseInt(price.customerGroup.id) === 113;
                                });
                                break;
                            case 104:
                                article_price = article.prices.find(price => {
                                    return parseInt(price.customerGroup.id) === 114;
                                });
                                break;
                            case 105:
                                article_price = article.prices.find(price => {
                                    return parseInt(price.customerGroup.id) === 115;
                                });
                                break;
                            case 106:
                                article_price = article.prices.find(price => {
                                    return parseInt(price.customerGroup.id) === 116;
                                });
                                break;
                            case 110:
                                article_price = article.prices.find(price => {
                                    return parseInt(price.customerGroup.id) === 117;
                                });
                                break;
                            default:
                                article_price = article.price;
                                break;
                        }
                        range.from = Math.min(range.from, article_price[key]);
                        range.to = Math.max(range.from, article_price[key]);
                    }
                });

                if (range.from < range.to) {
                    string = 'ab ' + moneyFormat(range.from, code);
                    // string = moneyFormat(range.from, code) + ' - ' + moneyFormat(range.to, code);
                }
            }

            return string;
        },
        salePrice() {
            if (!this.product.salePrice) return null;

            const code =
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR';

            let key = 'value';
            if (this.customer && get(this.customer, 'show_net_prices')) key = 'net_value';

            // return moneyFormat(salePrice.value - tax, code);
            let string = moneyFormat(this.product.salePrice[key], code);

            // get all sale prices from related articles
            // define range

            let range = {
                from: this.product.salePrice[key],
                to: this.product.salePrice[key]
            };

            if (this.validArticles && this.validArticles.length) {
                this.validArticles.forEach(article => {
                    if (article.salePrice) {
                        range.from = Math.min(range.from, article.salePrice[key]);
                        range.to = Math.max(range.from, article.salePrice[key]);
                    }
                });

                if (range.from < range.to) {
                    string = 'ab ' + moneyFormat(range.from, code);
                    // string = moneyFormat(range.from, code) + ' - ' + moneyFormat(range.to, code);
                }
            }

            return string;
        },
        priceRange() {
            if (!this.product.price) return null;

            const code =
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR';

            let key = 'value';
            if (this.customer && get(this.customer, 'show_net_prices')) key = 'net_value';

            let string;

            // get all prices from related articles
            // define range

            let price = this.product.salePrice?.[key] || this.product.price?.[key];

            let range = {
                from: price,
                to: price
            };

            if (this.validArticles && this.validArticles.length) {
                this.validArticles.forEach(article => {
                    const articlePrice = article?.salePrice || article?.price;
                    if (articlePrice) {
                        range.from = Math.min(range.from, articlePrice[key]);
                        range.to = Math.max(range.to, articlePrice[key]);
                    }
                });

                if (range.from < range.to) {
                    // string = 'ab ' + moneyFormat(range.from, code);
                    string = moneyFormat(range.from, code) + ' - ' + moneyFormat(range.to, code);
                }
            }

            return string;
        },
        maxQty() {
            let maxQty = Infinity;
            if (this.validArticles && this.validArticles.length === 1 && this.validArticles[0].qty_sum !== null)
                maxQty = this.validArticles[0].qty_sum;
            return maxQty;
        },
        activeMedia() {
            const m = Math.min(this.media.length - 1, this.m);
            return this.media[m];
        },
        visibleProperties() {
            return this.properties.filter(property => {
                return (
                    property.visible !== false || property.options.length > 1
                    // || (property.options.length === 1 && property.options[0].value !== this.description)
                );
            });
        },
        articleProperties() {
            return this.visibleProperties.filter(property => {
                return property.articleRequired;
            });
        },
        configurableArticleProperties() {
            return this.properties.filter(property => {
                return property.options && property.options.length > 1 && property.articleRequired;
            });
        },
        configurableProductProperties() {
            return this.properties.filter(property => {
                return property.options && property.options.length > 1 && property.articleRequired === false;
            });
        },
        nonConfigurableProperties() {
            return this.properties.filter(property => property.options && property.options.length <= 1);
        },
        validPropertySelection() {
            let valid = false;
            const pendingProperties = this.properties.filter(property => {
                return property.options.length > 1 && !this.selectedOptions[property.id];
            });
            if (!pendingProperties.length) valid = true;
            return valid;
        },
        sellableArticles() {
            let articles = this.product.articles;

            // pay attention to stock
            const manageStock = this.product.manage_stock;
            if (manageStock && this.product.articles && this.product.articles.length)
                articles = this.product.articles.filter(article => article.qty_sum > 0);
            return articles;
        },
        validArticles() {
            let articles = this.sellableArticles;
            if (this.sellableArticles && this.sellableArticles.length) {
                articles = this.sellableArticles.filter(article => {
                    let match = true;

                    // check qty in cart
                    // qty in cart must be smaller
                    // than article.qty_sum (if manageStock)
                    if (this.product.manage_stock) {
                        let cartQty = 0;
                        this.cart.articlePivots.forEach(articlePivot => {
                            if (articlePivot.article.id === article.id) cartQty += articlePivot.qty;
                        });
                        if (article.qty_sum <= cartQty) match = false;
                    }
                    // all property pivots must match
                    if (match) {
                        article.propertyPivots.forEach(el => {
                            const property = el.property;
                            const value = el.value;
                            if (this.selectedOptions[property.id]) {
                                const option = this.selectedOptions[property.id];
                                if (value[option.key] !== option.value) match = false;
                            }
                        });
                    }
                    return match;
                });
            }
            return articles;
        },
        articleGroups() {
            let groups = [];
            const ints = this.product.articles.reduce((acc, article) => {
                if (!acc.includes(article.int)) acc.push(article.int);
                return acc;
            }, []);

            if (ints.length) {
                ints.forEach(nr => {
                    const articles = this.product.articles.filter(el => el.int === nr);
                    if (articles.length) {
                        groups.push({
                            nr,
                            name: articles.find(el => !!el.str)?.str,
                            articles,
                            properties: this.getArticleProperties(articles)
                        });
                    }
                });
            } else {
                groups.push({
                    nr: undefined,
                    name: undefined,
                    articles: this.product.articles,
                    properties: this.articleProperties
                });
            }

            return groups.sort((a, b) => parseInt(a.name) - parseInt(b.name));
        },
        relatedArticles() {
            return this.product?.relatedArticles
        },
        ...mapGetters({
            customer: 'shop/customer',
            defaultCustomerGroup: 'shop/defaultCustomerGroup',
            defaultTax: 'shop/defaultTax',
            cart: 'shop/cart'
        })
    },
    methods: {
        getArticleProperties(articles) {
            let articleProperties = [];
            articles.forEach(article => {
                article.propertyPivots.forEach(pivot => {
                    const i = articleProperties.findIndex(el => el.id === pivot.property.id);
                    let property;
                    if (i >= 0) {
                        property = articleProperties[i];
                    } else {
                        property = cloneDeep(this.properties.find(el => el.id === pivot.property.id));
                        // property.options.forEach(option => option.disabled = true)
                        articleProperties.push(property);
                        property.options = [];
                    }

                    // const o = property.options.findIndex(el => el.value === pivot.value[pivot.property.key]);
                    // property.options.push()

                    const propType = pivot.property.propType;
                    const key = propType.value_field;
                    const value = get(pivot.value, key);

                    let valueAlt;
                    const keyAlt = propType.value_field_alt;
                    if (keyAlt) valueAlt = get(pivot.value, keyAlt);

                    const option = {
                        id: pivot.value.id,
                        image: pivot.value.image,
                        value,
                        valueAlt,
                        key
                    };

                    if (!property.options.find(el => el.value === option.value && el.valueAlt === option.valueAlt)) {
                        property.options.push(option);
                    }
                });
            });

            return articleProperties;
        },
        // getPrice(key = 'price') {
        //     const code =
        //         get(this.customer, 'customerGroup.currency.iso4217') ||
        //         get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
        //         'EUR';

        //     let string = moneyFormat(this.product[key].value, code);

        //     // get all prices from related articles
        //     // define range

        //     let range = {
        //         from: this.product[key].value,
        //         to: this.product[key].value
        //     };

        //     if (this.validArticles && this.validArticles.length) {
        //         this.validArticles.forEach(article => {
        //             if (article[key]) {
        //                 range.from = Math.min(range.from, article[key].value);
        //                 range.to = Math.max(range.from, article[key].value);
        //             }
        //         });

        //         if (range.from < range.to) {
        //             string = 'ab ' + moneyFormat(range.from, code);
        //             // string = moneyFormat(range.from, code) + ' - ' + moneyFormat(range.to, code);
        //         }
        //     }

        //     return string;
        // },
        calculateMediaWidth() {
            if (this.$refs.media) {
                const style = getComputedStyle(this.$refs.media);
                this.mediaWidth = this.$refs.media.clientWidth;
                this.mediaWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
            }
        },
        focus() {
            this.setFocusedMedia({ product: this.product, media: this.media });
        },
        leave() {
            this.removeFocusedMedia();
        },
        selectMedia(m) {
            this.m = m;
        },
        toggleActiveArticle(article) {
            if (article && article.media) {
                this.activeArticle = article;
            }
        },
        selectPropertyOption({ property, option }) {
            if (this.selectedOptions[property.id] && this.selectedOptions[property.id].id === option.id) {
                this.$delete(this.selectedOptions, property.id);
            } else {
                const value = { label: property.label, articleRequired: property.articleRequired, ...option };
                this.$set(this.selectedOptions, property.id, value);
                // check if there are validArticles
                // if not delete all selectedOptions
                // that are not available in combination
                // with the latest selection

                if (this.sellableArticles.length) {
                    let attempts = 0;
                    while (!this.validArticles.length && attempts < 1) {
                        ++attempts;
                        let match = false;
                        if (!match) {
                            this.properties.forEach(prop => {
                                if (
                                    prop.articleRequired &&
                                    prop.options.length &&
                                    this.selectedOptions[prop.id] &&
                                    prop.id !== property.id
                                ) {
                                    // find sellable article with selected options
                                    // without the current opt
                                    // if there are some, delete this prop from selectedOptions

                                    const articles = this.sellableArticles.filter(article => {
                                        // all property pivots must match
                                        let match = true;
                                        article.propertyPivots.forEach(el => {
                                            const property = el.property;
                                            const value = el.value;
                                            if (prop.id !== property.id && this.selectedOptions[property.id]) {
                                                const option = this.selectedOptions[property.id];
                                                if (value[option.key] !== option.value) match = false;
                                            }
                                        });
                                        return match;
                                    });

                                    if (articles.length) {
                                        this.$delete(this.selectedOptions, prop.id);
                                        match = true;
                                    }
                                }
                            });
                        }
                    }
                }
            }
            this.focus('main');
        },
        addToCart() {
            if (!this.validArticles || this.validArticles.length > 1) {
                const errorMessage = {
                    id: uniqid(),
                    title: 'Fehler',
                    text:
                        'Es gibt ein technisches Problem.<br>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                    type: 'error',
                    autoclose: 8000
                };
                this.addMessage(errorMessage);
            } else {
                let article = this.validArticles[0];
                article.product = cloneDeep(this.product);
                delete article.product.articles;

                let productPropertyValues = [];
                Object.keys(this.selectedOptions).map(key => {
                    if (!this.selectedOptions[key].articleRequired)
                        productPropertyValues.push(this.selectedOptions[key].id);
                });

                this.addArticleToCart({ article, productPropertyValues, qty: parseInt(this.qty) });

                const properties = Object.keys(this.selectedOptions)
                    .map(key => `${this.selectedOptions[key].label}: ${this.selectedOptions[key].value}`)
                    .join('<br>');

                const text = `
                    <p>Der folgende Artikel wurde Ihrem Warenkorb hinzugefügt</p>
                    <blockquote class="mt-2 pl-3 border-l-2 border-white border-opacity-50">
                    <h4 class="text-xl leading-none mb-1">${this.name}</h4>
                    <p class="text-xs mb-2 text-white text-opacity-75">#${this.nr}</p>
                    <p>${properties}</p>
                    <p>Preis: ${this.price}</p>
                    </blockquote>
                `;

                const message = {
                    id: uniqid(),
                    text,
                    type: 'success',
                    autoclose: 4000
                };
                this.addMessage(message);

                this.selectedOptions = {};
                this.qty = 1;
            }
        },
        ...mapMutations({
            setFocusedMedia: 'shop/setFocusedMedia',
            removeFocusedMedia: 'shop/removeFocusedMedia',
            setProduct: 'shop/setProduct'
        }),
        ...mapActions({
            addMessage: 'message/add',
            addArticleToCart: 'shop/addArticleToCart',
            fetchProduct: 'shop/fetchProduct'
        })
    },
    mounted() {
        this.loading = true;

        this.fetchProduct({ slug: this.$route.params.product })
            .then(product => {
                this.product = product;
                // this.setProduct(product);
                setTimeout(this.calculateMediaWidth, 0);

                this.transition['slide-fade-enter-active'] = true;
                setTimeout(() => (this.transition['slide-fade-enter'] = false), 0);
                setTimeout(() => (this.transition['slide-fade-enter-active'] = false), 300);
            })
            .finally(() => {
                this.loading = false;
            });

        this.debouncedCalculateMediaWidth = debounce(this.calculateMediaWidth, 100);
        window.addEventListener('resize', this.debouncedCalculateMediaWidth);
    },
    beforeRouteLeave(to, from, next) {
        this.transition['slide-fade-leave-active'] = true;
        this.transition['slide-fade-leave-to'] = true;
        next();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.debouncedCalculateMediaWidth);
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.product-details
    margin-top: 20px
    @screen lg
        margin-top: 3rem

.loading > section
    min-height: 140px

.preorder + h3
    margin-top: 2rem

.thumbnails::v-deep
    @apply mt-8 relative
    .hooper
        height: auto

        &.hideNavXS .hooper-navigation
            @screen max-lg
                @apply hidden

        &.hideNavLG .hooper-navigation
            @screen lg
                @apply hidden

        .hooper-slide
            display: flex
            justify-content: center

        .hooper-navigation
            @apply absolute w-full
            top: 50%

            > button
                @apply block absolute cursor-pointer z-50 bg-no-repeat p-0 m-0 rounded-full
                background-size: auto 30px
                background-position: center center
                background-color: rgba(229, 231, 235, 0.8)
                text-indent: -9999px
                width: 38px
                height: 38px
                text-align: center
                outline: 0
                &.is-disabled
                    cursor: not-allowed
                .icon
                    margin: 0 auto
                &:hover
                    @apply bg-no-repeat
                    background-color: rgba(229, 231, 235, 0.8)
                    background-position: center center
                    background-size: auto 30px
                    opacity: 0.5
.preorder-table
    @apply mt-8

label
    font-weight: 700
    color: #000
    font-size: 16px

.info-container
    @apply flex justify-between mt-4 mb-8
    @screen md
        @apply mt-0
    .name-wrap
        width: 50%
        margin-bottom: 1rem
        .name
            @apply text-lg font-bold
        .nr
            @apply text-sm
    .price-warp
        display: grid
        align-self: baseline
        @apply text-right
        .ek-price
            @apply text-lg font-bold
        .uvp-price
            color: $color-primary
            @apply text-lg font-bold
        .tax-info
            @apply text-sm

.properties
    margin-bottom: 1.5rem
    .property
        margin-bottom: 1rem

.details
    position: relative
    ::v-deep .drift-zoom-pane
        @apply rounded overflow-hidden
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 80vh

.add-to-shopping-cart
    @apply bg-gray-900 border-gray-600 rounded-none text-xs
    @screen lg
        @apply text-base

.buttons
    @apply flex
    justify-content: space-between
    opacity: .2
    pointer-events: none
    transition: opacity .15s ease
    margin-bottom: 5rem
    &.active
        pointer-events: initial
        opacity: 1
    .left
        display: flex
        flex-grow: 1
        justify-content: flex-start
        padding-right: 1rem

.custom-number-input
    @apply w-32 flex flex-row rounded-lg relative
    button
        @apply bg-white text-gray-600 h-full w-20 cursor-pointer outline-none
        height: 2.5rem
        &:hover,
        &:focus
            @apply text-gray-700 bg-gray-100
        &.decrease
            @apply rounded-l
        &.increase
            @apply rounded-r
    input
        @apply outline-none rounded-none text-center w-full bg-white font-semibold flex items-center text-gray-700
        @apply shadow-none #{! important}
        height: 2.5rem
        &:hover,
        &:focus
            @apply text-black

@screen md
    .product-details
        display: flex
        flex-direction: column
        & > div
            width: 100%
        .loading
            display: flex
            width: 100%
        .details
            display: grid
            grid-template-rows: auto
            grid-template-columns: minmax(0, 1fr) minmax(0, 1fr)
            grid-gap: 6rem
            &.hasThumbnails
                @apply auto-rows-auto
                grid-template-columns: 238px 150px minmax(0, 1fr)
                grid-gap: 1rem
                @screen lg
                    grid-template-columns: 404px 72px minmax(0, 1fr)
                .info
                    margin-left: 1.5rem
            &.hasThumbnails.thumbnails2Rows
                grid-template-columns: 238px 160px minmax(0, 1fr)
                @screen lg
                    grid-template-columns: 404px 160px minmax(0, 1fr)

    .info
        position: relative
        ::v-deep .drift-zoom-pane
            @apply rounded overflow-hidden
            position: absolute
            left: -5rem
            top: 0
            width: calc(100% + 5rem)
            height: 60vh


input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button
    -webkit-appearance: none
    margin: 0

.custom-number-input input:focus
    outline: none !important

.custom-number-input button:focus
    outline: none !important

.strikethrough
  font-size: 0.8em
  opacity: 0.6
  color: $black
  &:before
    border-color: theme('colors.gray.700')

.price
  position: relative
  .tax-info
    font-size: 1rem
    margin-bottom: 0.5rem
.price nobr + nobr.sale
  margin-left: 1rem
  color: theme('colors.red.600')
  position: relative
  z-index: 1
  &:before
    content: ''
    position: absolute
    // background-color: theme('colors.red.100')
    background-color: #e6ff15
    width: calc(100% + 8px)
    height: calc(100% + 4px)
    left: -4px
    top: -7px
    z-index: -1
    transform: rotate(-9deg) skew(-2deg, 0deg)
.description.mb-6
    white-space: break-spaces

.label-image
    max-height: 150px
    max-width: 150px

.carelabel-image
    max-width: 220px
    margin-bottom: 1.5rem

.sale-image
    position: absolute
    top: 1rem
    right: 1rem
</style>
